import React from 'react';
import { makeStyles, Popover } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none'
    },
    paper: {
        padding: theme.spacing(1),
        background: 'black'
    },
    text: {
        color: 'white'
    }
}));
function AttributeDetailsPopover({ open, anchorEl, attr, onClose }) {
    const classes = useStyles();
    return (React.createElement(Popover, { className: classes.popover, classes: {
            paper: classes.paper
        }, open: open, anchorEl: anchorEl, anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
        }, transformOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        }, onClose: onClose, disableEnforceFocus: true }, Object.entries(attr).map(([key, value]) => (React.createElement("div", { key: key, className: classes.text }, `${key}: ${value}`)))));
}
export default AttributeDetailsPopover;
